import { render, staticRenderFns } from "./AddJangkaPendek.vue?vue&type=template&id=ce704f12&lang=pug&"
import script from "./AddJangkaPendek.vue?vue&type=script&lang=js&"
export * from "./AddJangkaPendek.vue?vue&type=script&lang=js&"
import style0 from "./AddJangkaPendek.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports